import { FC, memo } from 'react';
import { clx, formatTimeToCET } from 'Utils';
import { EventType, IntegrationPartnerEvent } from 'Types';
import styles from 'partials/marketing/integration-event.module.scss';

interface Props {
	event: IntegrationPartnerEvent;
	communityPartnerName: string;
}

export const IntegrationEventCard: FC<Props> = memo(
	({ event, communityPartnerName }) => {
		const encodedURI = event.featuredPhoto?.replace(/\s+/g, '%20');
		const startDate = event?.startDate
			? formatTimeToCET(event?.startDate)
			: '';

		const getCoverBadgeLabel = (eventType: any) => {
			let badgeLabel = '';
			switch (eventType) {
				case EventType.Online:
					badgeLabel = 'Online';
					break;
				case EventType.InPerson:
					badgeLabel = 'Präsenz';
					break;
				case EventType.Hybrid:
					badgeLabel = 'Hybrid';
					break;

				default:
					badgeLabel = 'Online';
					break;
			}
			return badgeLabel;
		};

		return (
			<article className={styles.card}>
				<header className={clx(styles.header, 'flex-md-row')}>
					<div className="d-flex align-items-center w-100 w-sm-auto">
						<div className={styles.imageBox}>
							<a
								href={event?.url}
								rel="noreferrer"
								target="_blank">
								<img
									src={encodedURI}
									alt={communityPartnerName}
									className={styles.image}
								/>
							</a>
						</div>
						<div className={styles.mobile_company}>
							<h6
								className="mb-0 fs-sm text-truncate flex-grow-1"
								title={communityPartnerName}>
								{communityPartnerName}
							</h6>
						</div>
					</div>
					<div className={styles.content}>
						<h3 className={styles.title}>
							<a
								href={event?.url}
								target="_blank"
								rel="noreferrer">
								{event.title}
							</a>
						</h3>
						<div className="d-flex align-items-center mt-auto pt-2">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="me-1 flex-shrink-0"
								width="18"
								height="18"
								viewBox="0 0 24 24"
								stroke="currentColor"
								strokeWidth="1"
								fill="none"
								strokeLinecap="round"
								strokeLinejoin="round">
								<path
									stroke="none"
									d="M0 0h24v24H0z"
									fill="none"></path>
								<circle cx="12" cy="11" r="3"></circle>
								<path d="M17.657 16.657l-4.243 4.243a2 2 0 0 1 -2.827 0l-4.244 -4.243a8 8 0 1 1 11.314 0z"></path>
							</svg>
							<span className={styles.location}>
								{event?.address.postalCode}{' '}
								{event?.address.city}
							</span>
						</div>
					</div>
				</header>
				<div className="my-2">
					<span className="text-sm font-medium bg-gray-2 p-1 rounded">
						{getCoverBadgeLabel(event.eventType)}
					</span>
				</div>
				<div className="d-flex flex-col gap-1 flex-wrap">
					<div>
						<time dateTime={event?.startDate}>{startDate}</time>
					</div>
				</div>
				<div
					className={clx(
						styles.footer,
						'd-none d-md-flex align-items-center'
					)}>
					<h6
						className="mb-0 fw-400 text-truncate fs-sm flex-grow-1"
						title={communityPartnerName}>
						{communityPartnerName}
					</h6>
				</div>
			</article>
		);
	}
);

IntegrationEventCard.displayName = 'IntegrationEventCard';
